<icp-splitted-screen [fullContainer]="true" [contrastSide]="contrastSide">
  <ng-container left-content>
    <icp-carousel [images]="images"></icp-carousel>
  </ng-container>
  <ng-container right-content>
    <icp-onboarding
      [actions]="actions"
      [disabled]="form.invalid"
      (onClickButton)="submitForm()"
    >

      <ng-container form-content>
        <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="form-horizontal">
          <div class="input-group">
            <icp-input
                id="email"
                name="email"
                label="E-mail"
                placeholder="Digite seu e-mail"
                type="email"
                formControlName="email"
                [messageError]="formErrors.email"
                autocomplete="off"
                ></icp-input>
              </div>
              <div class="input-group">
                <icp-input
                id="password"
                name="password"
                label="Nova Senha" placeholder="Digite sua nova senha" type="password"
                formControlName="password"
                autocomplete="off"
                [messageError]="formErrors.password">
              </icp-input>
            </div>
            <div class="input-group">
              <icp-input
              id="password_confirmation"
              name="password_confirmation"
              label="Nova Senha" placeholder="Digite sua nova senha" type="password"
              formControlName="password_confirmation"
              [messageError]="formErrors.password_confirmation"
              autocomplete="off"
              (keyup.enter)="submitForm()">
            </icp-input>
          </div>
        </form>
      </ng-container>
    </icp-onboarding>
  </ng-container>
</icp-splitted-screen>